import React from 'react';
import { Navigate } from 'react-router';
import { SettingsConfig } from './settingsConfig';

export function createSettingsModule(config: SettingsConfig) {
    const {
        config: { items },
    } = config;

    const DefaultRedirect = () => {
        const firstPath = items.filter((item) => item.scope === 'user')[0]?.path;
        return <Navigate to={firstPath} replace={true} />;
    };

    return {
        Route: config.providers.createContainer(
            config.deps,
            config.providers.createController(config.deps),
            config.providers.createView(config)
        ),
        Redirect: DefaultRedirect,
        items,
    };
}
